// src/components/NewAccountCodeModal.jsx
import React, { useState } from 'react';

const NewAccountCodeModal = ({ code, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-content--confirm account-code-modal">
        <div className="payment-header">
          <div className="payment-icon">🔑</div>
          <h2 className="payment-title font-cinzel">Guardá tu código</h2>
        </div>
        <p className="zodiac-tool-desc">
          Creamos tu código secreto de recuperación. Es la <strong>única forma</strong> de acceder a tus compras
          y lecturas desde otro dispositivo, o si borrás los datos de este navegador.
        </p>
        <div className="account-code-display">
          <span className="account-code-value">{code}</span>
          <button className="main-button primary-button" onClick={handleCopy}>
            {copied ? '¡Copiado!' : 'Copiar'}
          </button>
        </div>
        <p className="account-warning">
          ⚠️ Nadie de Tarot Místico te lo va a pedir nunca. Guardalo ahora en un lugar seguro — no vamos a poder
          recuperarlo por vos si lo perdés.
        </p>
        <label className="account-confirm-checkbox">
          <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
          Ya guardé mi código en un lugar seguro
        </label>
        <button
          className="main-button primary-button payment-btn-full"
          onClick={onClose}
          disabled={!confirmed}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default NewAccountCodeModal;
